import type { AddressBook } from "../../repository/AddressBookRepository.ts";
import { formatAddress } from "../../utils/formatAddress.ts";
import { openExplorerInNewTab } from "../../utils/explorerHelper.ts";
import {ExternalLinkIcon} from "lucide-react";

const LoadingContractAddressTables = () => {
  return (
    <tbody>
      {Array.from({ length: 2 }, (_, index) => (
        <tr key={index}>
          <td>
            <div className="skeleton h-10 w-full" />
          </td>
          <td className="w-full">
            <div className="skeleton h-10 w-full" />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const ContractAddressRow = ({
  contractName,
  address,
}: {
  contractName: string;
  address: string;
}) => {
  //TODO retirer le check si l'adresse est "TBD"

  return (
    <tr>
      <td>{contractName}</td>
      <td>{address != "TBD" ? formatAddress(address, true) : "TBD"}</td>
      <td>
        <button
          className="btn btn-sm"
          onClick={() => openExplorerInNewTab(address)}
        >
          <ExternalLinkIcon />
        </button>
      </td>
    </tr>
  );
};

const ContractAddressTables = ({
  isLoading,
  addressBook,
}: {
  isLoading: boolean;
  addressBook: AddressBook;
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="table">
        <thead>
          <tr>
            <th>Contract name</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>
        {isLoading ? (
          <LoadingContractAddressTables />
        ) : (
          <tbody>
            <ContractAddressRow
              contractName={"Factory"}
              address={addressBook.factory}
            />
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ContractAddressTables;
